import { useId } from "react";

interface RevealedTruthProps {
  className?: string;
}

/**
 * ALETHEIA "Revealed Truth" motif (Concept 2) — an architectural opened A
 * with a central light beam, symbolizing truth unveiled. This is the
 * secondary brand treatment: a large, low-opacity atmospheric device for
 * editorial moments (the Welcome screen), never the compact mark used for
 * the avatar/favicon/app icon — that's <Logo /> (Concept 1).
 *
 * Purely decorative (aria-hidden): it sits behind real content, never
 * carries information on its own.
 */
export function RevealedTruth({ className }: RevealedTruthProps) {
  const bronzeId = useId();
  const beamId = useId();
  return (
    <svg viewBox="0 0 240 200" aria-hidden="true" className={className}>
      <defs>
        <linearGradient id={bronzeId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--color-accent-strong)" />
          <stop offset="55%" stopColor="var(--color-accent)" />
          <stop offset="100%" stopColor="var(--color-accent-deep)" />
        </linearGradient>
        <linearGradient id={beamId} x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="var(--color-ink)" stopOpacity="0.95" />
          <stop offset="45%" stopColor="var(--color-accent-strong)" stopOpacity="0.55" />
          <stop offset="100%" stopColor="var(--color-accent-strong)" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d="M120,22 L24,180 L70,180 L116,32 Z" fill={`url(#${bronzeId})`} />
      <path d="M120,22 L216,180 L170,180 L124,32 Z" fill={`url(#${bronzeId})`} />
      <path d="M120,40 L129,180 L111,180 Z" fill={`url(#${beamId})`} />
    </svg>
  );
}
